import React from 'react';
import { useStats } from 'react-instantsearch-hooks-web';

const SearchTabToggle = ( props ) => {
	const { isActive, onClick, label } = props;
	const stats = useStats();

	return (
		<div className='z-10 flex'>
			<button
				type="button"
				aria-label={`Change search tab to ${ label }`}
				className={`tw-bg-transparent tw-text-base lg:tw-text-lg tw-font-medium hover:tw-text-charcoal tw-border-b-4 tw-pb-2 tw-mb-0 ${ isActive ? 'tw-text-charcoal tw-border-apple' : 'tw-text-slate tw-border-transparent' }`}
				onClick={() => onClick( )}>
				{stats.nbHits} {label}
			</button>
		</div>
	);
};

export default SearchTabToggle;
